function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "top_l") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bg"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1280 0 616.08 0 704.39 77.27 713.26 88.63 713.26 88.63 796.39 195.03 817.53 272.78 899.42 574.04 1042.93 695.47 1051.97 720 1280 720 1280 0",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.15 412.13 373.22 342.21 407.31 272.78 472.57 139.83 525.12 88.63 616.08 0 0 0 0 720 157.58 720 181.87 551.96 259.15 412.13",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.31 272.78 407.31 272.78 582.56 370.43 484.52 315.8 407.31 272.78",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "713.26 88.63 704.39 77.27 616.08 0 688.76 63.6 713.26 88.63",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.31 272.78 373.22 342.21 407.31 272.78 407.31 272.78",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.93 542.15 245.42 720 284.35 720 338.47 668.08 376.9 592.85 551.07 409.68 582.56 370.43 407.31 272.78 373.22 342.21 327.02 401.5 322.93 542.15",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "866.61 720 943.7 720 938.67 697.51 922.32 648.45 820.92 565.04 886.34 681.16 866.61 720",
    style: {
      fill: "#e7e7e7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "820.92 565.04 922.32 648.45 938.67 697.51 943.7 720 1051.97 720 1042.93 695.47 820.92 565.04",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "726.47 607.15 693.45 720 795.01 720 726.47 607.15",
    style: {
      fill: "#e3e3e3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "790.25 517.62 820.92 565.04 1042.93 695.47 899.42 574.04 781.67 463.65 790.25 517.62",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "866.61 720 886.34 681.16 820.92 565.04 830.17 720 866.61 720",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "581.43 720 594 674.62 602.59 607.15 545.08 720 581.43 720",
    style: {
      fill: "#e3e3e3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "817.53 272.78 796.39 195.03 817.53 272.78 817.53 272.78",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "817.53 272.78 796.39 195.03 789.03 225.69 817.53 272.78",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "899.42 574.04 817.53 272.78 817.53 272.78 899.42 574.04",
    style: {
      fill: "#f1f1f1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "789.03 285.79 738.74 272.78 777.38 444.56 781.67 463.65 899.42 574.04 817.53 272.78 789.03 285.79",
    style: {
      fill: "#f1f1f1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "796.39 195.03 713.26 88.63 713.26 88.63 796.39 195.03",
    style: {
      fill: "#fbfbfb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.57 121.43 721.57 166.81 746.1 176.63 789.03 225.69 796.39 195.03 713.26 88.63 721.57 121.43",
    style: {
      fill: "#fbfbfb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "640 56.42 688.76 63.6 616.08 0 616.08 40.48 640 56.42",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "781.67 463.65 777.38 444.56 640 423.41 602.59 607.15 594 674.62 581.43 720 693.45 720 726.47 607.15 795.01 720 830.17 720 820.92 565.04 790.25 517.62 781.67 463.65",
    style: {
      fill: "#ececec"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "781.67 463.65 777.38 444.56 777.38 444.56 781.67 463.65",
    style: {
      fill: "#ececec"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "630.8 361.84 640 423.41 777.38 444.56 738.74 272.78 676.18 258.81 630.8 361.84",
    style: {
      fill: "#f3f3f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "777.38 444.56 738.74 272.78 777.38 444.56 777.38 444.56",
    style: {
      fill: "#f3f3f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "817.53 272.78 817.53 272.78 817.53 272.78 817.53 272.78",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "713.26 225.69 676.18 258.81 738.74 272.78 789.03 285.79 817.53 272.78 817.53 272.78 789.03 225.69 763.07 233.9 713.26 225.69",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "525.12 88.63 616.08 0 525.12 88.63 525.12 88.63",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "569.47 114.07 576.83 74.82 595.23 52.74 640 56.42 616.08 40.48 616.08 0 525.12 88.63 569.47 114.07",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "789.03 225.69 746.1 176.63 721.57 166.81 763.07 233.9 789.03 225.69",
    style: {
      fill: "#f6f6f6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "713.26 88.63 713.26 88.63 713.26 88.63 713.26 88.63",
    style: {
      fill: "#fcfcfc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "640 56.42 667.6 74.82 695.81 120.2 721.57 166.81 721.57 121.43 713.26 88.63 713.26 88.63 688.76 63.6 640 56.42",
    style: {
      fill: "#fcfcfc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "713.26 225.69 763.07 233.9 721.57 166.81 695.81 120.2 667.6 74.82 640 56.42 595.23 52.74 576.83 74.82 569.47 114.07 676.18 258.81 713.26 225.69",
    style: {
      fill: "#fdfdfd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.87 551.96 157.58 720 207.61 720 181.87 551.96",
    style: {
      fill: "#e9e9e9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.93 542.15 327.02 401.5 181.87 551.96 207.61 720 245.42 720 322.93 542.15",
    style: {
      fill: "#eee"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.37 720 539.26 720 558.43 551.96 363.41 650.82 348.37 720",
    style: {
      fill: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "582.56 370.43 551.07 409.68 558.43 551.96 539.26 720 540.5 720 569.47 574.04 619.76 463.65 602.59 607.15 640 423.41 630.8 361.84 582.56 370.43",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.35 720 331.49 720 338.47 668.08 284.35 720",
    style: {
      fill: "#e2e2e2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "569.47 574.04 540.5 720 545.08 720 602.59 607.15 619.76 463.65 569.47 574.04",
    style: {
      fill: "#eaeaea"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "558.43 551.96 551.07 409.68 376.9 592.85 363.41 650.82 558.43 551.96",
    style: {
      fill: "#ededed"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.41 650.82 376.9 592.85 338.47 668.08 331.49 720 348.37 720 363.41 650.82",
    style: {
      fill: "#e4e4e4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "525.12 88.63 472.57 139.83 525.12 88.63 525.12 88.63",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "630.8 361.84 608.72 246.54 537.58 166.81 525.12 88.63 472.57 139.83 582.56 370.43 630.8 361.84",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "537.58 166.81 608.72 246.54 630.8 361.84 676.18 258.81 569.47 114.07 525.12 88.63 525.12 88.63 537.58 166.81",
    style: {
      fill: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "472.57 139.83 407.31 272.78 407.31 272.78 472.57 139.83",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "484.52 315.8 472.57 139.83 407.31 272.78 484.52 315.8",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "582.56 370.43 472.57 139.83 484.52 315.8 582.56 370.43",
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.22 342.21 259.15 412.13 181.87 551.96 327.02 401.5 373.22 342.21",
    style: {
      fill: "#f0f0f0"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopL);
export default __webpack_public_path__ + "static/media/top_l.78a85cb0744752b6c81cf0ee338e795d.svg";
export { ForwardRef as ReactComponent };